import React, { PropsWithChildren, useEffect, useState } from 'react'
import {
  DropDownListBlurEvent,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import DropdownOption from './DropdownOption';
import SearchableDropdown from './SearchableDropdown';
import { ChargeType } from '../../data/entities';

interface SearchableChargeTypeDropdownProps extends PropsWithChildren {
  value?: any;
  name: string;
  isInvalid?: boolean;
  onBlur?: (e: DropDownListBlurEvent) => void;
  onChange?: (e: DropDownListChangeEvent) => void;
  onSelect?: (value: DropdownOption) => void;
  placeholder?: string;
  defaultItem?: boolean;
  disabled?: boolean;
}

export const SearchableChargeTypeDropdown = React.forwardRef(
  (
    props: Readonly<SearchableChargeTypeDropdownProps>,
    ref: React.ForwardedRef<HTMLSelectElement | null>
  ) => {
    const [options, setOptions] = useState<DropdownOption[]>([]);

    useEffect(() => {
    
      const chargeTypeOptions = Object.values(ChargeType).map<DropdownOption>((type)=>({
        value: type.toString(),
        text: type.toString()
      }))
      setOptions(chargeTypeOptions)

    }, []);

    const getValue = () => {
      if (!props.value && props.defaultItem) {
        return { text: "Select a type...", value: "" }; 
      }
      return options.find((option) => option.value === props.value?.toString());
    };

    return (
      <SearchableDropdown
        defaultItem={props.defaultItem ? {text:"Select a type...", value: ""} : undefined}
        label="Charge Type"
        name={props.name}
        options={options}
        value={getValue()}
        onChange={props.onChange}
        onSelect={props.onSelect}
        isInvalid={props.isInvalid}
        disabled={props.disabled}
      >
        {props.children}
      </SearchableDropdown>
    );
  }
);

export default SearchableChargeTypeDropdown
